import ReportHeader from "../../../../../components/Reports/ReportHeader";
import PrintButton from "../../../../../components/Reports/Buttons/PrintButton";
import PciPerformanceReport from "./PciPerformanceReport";
import DowntimeReports from "./DowntimeReports";
import { PciReportProps } from "../../../../../types";

export default function PciMachineReport({
  dateString,
  subHeader,
  currentWeekNumber,
  completedYearlyData,
  shiftsDataArray,
  lastWeeksWeeklyResults,
  machineName,
  totalTimePerTagTargetWeekAggregateData,
  oeeTarget,
}: PciReportProps) {
  return (
    <>
      <ReportHeader
        title={`WEEKLY ${machineName.toUpperCase()} PERFORMANCE REPORT OVERVIEW`}
        dateString={dateString}
        rightSideComponent={<PrintButton />}
        subheader={subHeader}
      />
      <div className="main-div">
        <PciPerformanceReport
          completedYearlyData={completedYearlyData}
          currentWeekNumber={currentWeekNumber}
          shiftsDataArray={shiftsDataArray}
          oeeTarget={oeeTarget}
        />
        <DowntimeReports
          completedYearlyData={completedYearlyData}
          currentWeekNumber={currentWeekNumber}
          shiftsDataArray={shiftsDataArray}
          filteredtotalTimePerTagLastWeekData={
            totalTimePerTagTargetWeekAggregateData
          }
          lastWeeksWeeklyResults={lastWeeksWeeklyResults}
        />
      </div>

      <div className="print-div">
        <PciPerformanceReport
          completedYearlyData={completedYearlyData}
          currentWeekNumber={currentWeekNumber}
          shiftsDataArray={shiftsDataArray}
          shouldSetWidth={true}
          oeeTarget={oeeTarget}
        />
        <div className="other-header break-before">
          <ReportHeader
            title={`WEEKLY ${machineName.toUpperCase()} PERFORMANCE REPORT DOWNTIMES`}
            dateString={dateString}
            rightSideComponent={<PrintButton />}
            subheader={subHeader}
          />
        </div>
        <DowntimeReports
          completedYearlyData={completedYearlyData}
          currentWeekNumber={currentWeekNumber}
          shiftsDataArray={shiftsDataArray}
          filteredtotalTimePerTagLastWeekData={
            totalTimePerTagTargetWeekAggregateData
          }
          lastWeeksWeeklyResults={lastWeeksWeeklyResults}
          shouldSetWidth={true} // should set width is used to state that width needs to be static for print formatting
        />
      </div>
    </>
  );
}
